import LicenseService from './LicenseService.js'

const state = {
  license: null,
  licenseExpired: true
}

const getters = {
  license: state => state.license,
  licenseExpired: state => state.licenseExpired
}

const actions = {
  async getLicense({ commit }) {
    const result = await LicenseService.getLicenceData()
    commit('setLicense', result)
  },
  setLicense({ commit }, data) {
    commit('setLicense', data)
  }
}

const mutations = {
  setLicense(state, data) {
    state.license = data
    state.licenseExpired = data.isExpired && !data.isGracePeriod
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
